if($(".new_component_phone_swiper").length){

  hp.swipers = hp.swipers || {};
  var new_component_phone_swiper = 
  {
    initialized: false
  };

  new_component_phone_swiper.init = function(){

    var NewComponentProps = {
      pagination: {
        el: '.Newcomponent-module-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: ".new_component_phone_swiper .navigation_buttons .right-arrow-svg-carousel-new-component",
        prevEl: ".new_component_phone_swiper .navigation_buttons .left-arrow-svg-carousel-new-component",
      },
      lazy: false,
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      breakpoints: {
        1224: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        1124: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        800: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      }
    }
    var NewComponentMethods = {
      resizeHandler: true,
      a11ySwiper: true
    }

    var NewComponentProductsProps = {
      pagination: {
        el: '.Newcomponent-products-module-pagination',
        type: 'bullets',
        clickable: true,
      },
      lazy: false,
      slidesPerView: 2,
      spaceBetween: -1,
      loop: false,
      observer:true,
      breakpoints: {
        1224: {
          slidesPerView: 2,
          spaceBetween: -1
        },
        1124: {
          slidesPerView: 2,
          spaceBetween: -1
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: -1
        },
        800: {
          slidesPerView: 2,
          spaceBetween: -1
        },
        767: {
          slidesPerView: 1,
          spaceBetween: -1
        }
      }
    }
    var NewComponentProductMethods = {
      resizeHandler: true,
      a11ySwiper: true
    }

    var NewComponentProductsModule = hp.swiperInstance('.bottom_wrapper_swiper', NewComponentProductsProps, NewComponentProductMethods);
    
    new_component_phone_swiper.instances = hp.swiperInstance('.new_component_phone_swiper', NewComponentProps, NewComponentMethods);
    new_component_phone_swiper.initialized = true;

    jQuery(document).ready(function(){
      rearrange_new_component();
      $(window).resize(function(){
        //console.log($(window).width());
        rearrange_new_component();
      });
    });    
  }//end init
  
  function rearrange_new_component(){
    if(new_component_phone_swiper.instances.length > 1){
      for(var i = 0; i < new_component_phone_swiper.instances.length; i++){
        rearrangeComponent(new_component_phone_swiper.instances[i].$el);
        // NewComponentProductsModule[i].reInit();
      }      
    }else{
      rearrangeComponent(new_component_phone_swiper.instances);
    }
  }

  function rearrangeComponent(swiper){
    if($(window).width() < 767){
      var grid = $(swiper).parents(".Grid");
      var bottom_wrapper = $(swiper).parents(".bottom_wrapper").detach();
      var bottom_wrapper_md6 = document.createElement("div");
      var shop_all_cta = $(".new_component_shop_all_products", grid).detach();
      bottom_wrapper.append(shop_all_cta);
      $(bottom_wrapper_md6).addClass("Col-md-6 black");
      $(bottom_wrapper_md6).append(bottom_wrapper);
      grid.append(bottom_wrapper_md6).addClass("mobile");
    }else if(!$(swiper).parents(".Grid").hasClass("mobile")){
      $(swiper).parents(".Grid").addClass("mobile");
    }else{
      var grid = $(swiper).parents(".Grid");
      var shop_all_cta = $(".new_component_shop_all_products", $(swiper).parents(".Grid")).detach();
      $('.swiper-slide-duplicate', $(swiper).parents(".bottom_wrapper")).detach();
      var bottom_wrapper = $(swiper).parents(".bottom_wrapper").detach();
      $(".Col-md-6.black:not(:first-child)", grid).remove();
      $(".Col-md-6.black", grid).append(bottom_wrapper);
      $(".top-left-wrap-inner .Col-md-6.right", grid).append(shop_all_cta);
    }
  }

  hp.swipers.new_component_phone_swiper=new_component_phone_swiper;
}
